import { isElementNode } from 'anodum';

const hasCustomFontSize = (element) => {
  if (!isElementNode(element)) return false;
  return Boolean(element.style.getPropertyValue('--font-size'));
};

export default hasCustomFontSize;
